import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base.js';
var Login = {
  init: function init() {
    var self = this; // self.checkToken();

    $('.login-button').click(function () {
      self.doLogin();
    });
  },
  // checkToken: async function(){
  // var self = this;
  // var token = localStorage.getItem(Base.tokenKey);
  // if(token == null || token == undefined) {
  //   return false;
  // } else {
  //   let loader = Base.app.dialog.preloader('Hệ thống đang đăng nhập tự động...');
  //   var rs = await Base.api('App','checkToken',{});
  //   loader.close();
  //   if(rs.result == 'success') {
  //     Base.app.dialog.close();
  //     Base.token = localStorage.getItem(Base.tokenKey);
  //     Base.user = JSON.parse(localStorage.getItem(Base.userKey));
  //     //?nhaphang&ts=123456789
  //     const query = (window.location.search) ? window.location.search.replace('?','') : '';
  //     let page = '/dayoff/';
  //     let props = {};
  //     if(query !== '') {
  //       let arr = query.split('&');
  //       page = `/${arr[0]}/`;
  //       let y = arr[1].split('=');
  //       props.ts = y[1];
  //     }
  //     if(process.env.NODE_ENV === 'development') {
  //       Base.app.views.main.router.navigate(page, {props});
  //     } else {
  //       if(Base.user.role == 2) {
  //         Base.app.views.main.router.navigate('/employee/');
  //       } else {
  //         Base.app.views.main.router.navigate(page, {props});
  //       }
  //     }
  //   } else {
  //     Base.app.dialog.close();
  //     Base.app.dialog.alert('Đăng nhập tự động thất bại. Vui lòng đăng nhập lại.');
  //   }
  // }
  // },
  doLogin: function () {
    var _doLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var username, password, rs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              username = $('input[name=username]').val();
              password = $('input[name=password]').val();
              _context.next = 4;
              return Base.api('App', 'login', {
                username: username,
                password: password
              });

            case 4:
              rs = _context.sent;

              if (rs.result == 'success') {
                localStorage.setItem(Base.tokenKey, rs.token);
                localStorage.setItem(Base.userKey, JSON.stringify(rs.user));
                Base.token = rs.token;
                Base.user = rs.user;

                if (Base.user.role == 2) {
                  Base.app.views.main.router.navigate('/nvut/');
                } else {
                  Base.app.views.main.router.navigate('/home/');
                }
              } else {
                Base.app.dialog.alert(rs.message);
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function doLogin() {
      return _doLogin.apply(this, arguments);
    }

    return doLogin;
  }()
};
export default (function (props, ctx) {
  ctx.$on('page:init', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var token, rs, query, page, _props, arr, y;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            Login.init(); // var self = this;

            token = localStorage.getItem(Base.tokenKey);

            if (!(token == null || token == undefined)) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return", false);

          case 6:
            ctx.$f7.dialog.preloader('Hệ thống đang đăng nhập tự động...');
            _context2.next = 9;
            return Base.api('App', 'checkToken', {});

          case 9:
            rs = _context2.sent;

            // ctx.$f7.dialog.close();
            if (rs.result == 'success') {
              ctx.$f7.dialog.close();
              Base.token = localStorage.getItem(Base.tokenKey);
              Base.user = JSON.parse(localStorage.getItem(Base.userKey)); //?nhaphang&ts=123456789

              query = window.location.search ? window.location.search.replace('?', '') : '';
              page = '/home/';
              _props = {};

              if (query !== '') {
                arr = query.split('&');
                page = "/".concat(arr[0], "/");
                y = arr[1].split('=');
                _props.ts = y[1];
              }

              if (process.env.NODE_ENV === 'development') {
                ctx.$f7.views.main.router.navigate(page, {
                  props: _props
                });
              } else {
                if (Base.user.role == 2) {
                  ctx.$f7.views.main.router.navigate('/employee/');
                } else {
                  ctx.$f7.views.main.router.navigate(page, {
                    props: _props
                  });
                }
              }
            } else {
              ctx.$f7.dialog.close();
              ctx.$f7.dialog.alert('Đăng nhập tự động thất bại. Vui lòng đăng nhập lại.');
            }

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page no-navbar no-toolbar no-swipeback">
    <div class="page-content login-screen-content">
      <div class="login-screen-title">Hà Xinh - Quản lý</div>
      <form>
        <div class="list">
          <ul>
            <li class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">Tên truy cập</div>
                <div class="item-input-wrap">
                  <input type="text" name="username" placeholder="Tên truy cập của bạn" />
                </div>
              </div>
            </li>
            <li class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">Mật khẩu</div>
                <div class="item-input-wrap">
                  <input type="password" name="password" placeholder="Mật khẩu" />
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="list">
          <ul>
            <li><a href="#" class="list-button login-button">Đăng Nhập</a></li>
          </ul>
          <div class="block-footer">
            <p>Nhắc đến Phụ Kiện, Nhớ tới Hà Xinh</p>
          </div>
        </div>
      </form>
    </div>
  </div>
`
    }
    ;
});